"use strict";

var _slicedToArray = require("/home/circleci/repo/web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var util_1 = require("./util");

var useBattery = function useBattery() {
  var _react_1$useState = react_1.useState({}),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      state = _react_1$useState2[0],
      setState = _react_1$useState2[1];

  var mounted = true;
  var battery = null;

  var onChange = function onChange() {
    var _battery = battery,
        charging = _battery.charging,
        level = _battery.level,
        chargingTime = _battery.chargingTime,
        dischargingTime = _battery.dischargingTime;
    setState({
      charging: charging,
      level: level,
      chargingTime: chargingTime,
      dischargingTime: dischargingTime
    });
  };

  var onBattery = function onBattery() {
    onChange();
    util_1.on(battery, 'chargingchange', onChange);
    util_1.on(battery, 'levelchange', onChange);
    util_1.on(battery, 'chargingtimechange', onChange);
    util_1.on(battery, 'dischargingtimechange', onChange);
  };

  react_1.useEffect(function () {
    navigator.getBattery().then(function (bat) {
      if (mounted) {
        battery = bat;
        onBattery();
      }
    });
    return function () {
      mounted = false;

      if (battery) {
        util_1.off(battery, 'chargingchange', onChange);
        util_1.off(battery, 'levelchange', onChange);
        util_1.off(battery, 'chargingtimechange', onChange);
        util_1.off(battery, 'dischargingtimechange', onChange);
      }
    };
  }, [0]);
  return state;
};

exports.default = useBattery;